import type { EventSink } from '../events'
import type { Projectile, ProjectileKind, Trap, TrapKind, World } from '../world'
import { homingDrone } from './homing_drone'
import { leaderMissile } from './leader_missile'
import { oilSlick } from './oil_slick'
import { spikeBall } from './spike_ball'
import { tripWire } from './trip_wire'
import type { ProjectileItem, TrapItem } from './types'

const TRAPS: { readonly [K in TrapKind]: TrapItem } = { trip_wire: tripWire, oil_slick: oilSlick }

const PROJECTILES: { readonly [K in ProjectileKind]: ProjectileItem } = {
  spike_ball: spikeBall,
  homing_drone: homingDrone,
  leader_missile: leaderMissile,
}

/**
 * Step 5: update traps, then projectiles, each in array order (oldest first). Ones whose update
 * returns false (hit someone, expired, fell out, hit a wall) are removed; the rest keep their
 * order. Items spawned in step 7 first move on the next tick.
 */
export function stepTrapsAndProjectiles(world: World, events: EventSink): void {
  const traps: Trap[] = []
  for (const t of world.traps) {
    if (TRAPS[t.kind].update(world, t, events)) traps.push(t)
  }
  world.traps = traps

  const projectiles: Projectile[] = []
  for (const pr of world.projectiles) {
    if (PROJECTILES[pr.kind].update(world, pr, events)) projectiles.push(pr)
  }
  world.projectiles = projectiles
}
